var React = require('react');

function Instagram (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M12.988.045H3.181A3.086 3.086 0 0 0 .091 3.12v9.76a3.086 3.086 0 0 0 3.09 3.075h9.807a3.086 3.086 0 0 0 3.09-3.075V3.12a3.086 3.086 0 0 0-3.09-3.075zm.886 1.835l.354-.002v2.697l-2.702.008-.009-2.697 2.357-.006zm-8.07 4.487A2.814 2.814 0 0 1 10.898 8a2.81 2.81 0 0 1-2.814 2.8A2.81 2.81 0 0 1 5.27 8c0-.61.2-1.173.532-1.633zm8.716 6.513a1.53 1.53 0 0 1-1.532 1.525H3.181a1.53 1.53 0 0 1-1.532-1.525V6.367h2.387A4.3 4.3 0 0 0 3.714 8c0 2.398 1.96 4.35 4.37 4.35 2.411 0 4.372-1.952 4.372-4.35 0-.577-.117-1.128-.322-1.633h2.386v6.513z"}));
}

Instagram.defaultProps = {"width":"1em","height":"1em","viewBox":"0 0 17 16"};

module.exports = Instagram;

Instagram.default = Instagram;
